<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter"></h2>
<div class="blockquote1">
<p class="noindent"><em class="italic">I think everyone in the world is friends if you can only get them to see you don't want to be un-friends.</em></p>
<p class="right_1">EDITH NESBIT<a id="page_iii"></a></p><a id="page_iii">
</a></div><a id="page_iii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fm2.vue?3c6927a0